export default [
	{
		_name: 'CSidebarNav',
		_children: [
			{
				_name: 'CSidebarNavItem',
				name: 'Dashboard',
				to: '/dashboard',
				icon: 'cil-speedometer',
			},

			/** CLIENTS **/
			{
				_name: 'CSidebarNavTitle',
				_children: ['Clients'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Gestion des clients',
				to: '/clients/gestion-clients',
				icon: 'cil-people',
			},

			/** BORDEREAUX */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Bordereaux'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Réceptionner / Saisie',
				to: '/slips/receive',
				icon: 'cil-star',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Lier à un point de vente',
				to: '/slips/link-point-of-sale',
				icon: 'cil-star',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Historique',
				to: '/slips/history',
				icon: 'cil-star',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Retirer un bordereau',
				to: '/slips/remove',
				icon: 'cil-star',
			},

			/** COMMANDES */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Commandes'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Commandes',
				to: '/orders/list',
				icon: 'cil-cart',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Colis',
				to: '/orders/packages',
				icon: 'cil-basket',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'SAV',
				to: '/orders/customer-service/tickets',
				icon: 'cil-chat-bubble',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Caisses',
				to: '/orders/payments-history/list',
				icon: 'cil-euro',
			},

			/** ENTREPOT */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Entrepôt'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Interception colis',
				to: '/warehouse/blocked-packages',
				icon: 'cil-ban',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Imprimer les étiquettes',
				to: '/warehouse/generate-labels',
				icon: 'cil-print',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Déplacer les colis',
				to: '/warehouse/move-packages',
				icon: 'cil-print',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Production',
				to: '/warehouse/production',
				icon: 'cil-basket',
			},

			/** AERIAL */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Aérienne'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Vols',
				to: '/aerial/flights',
				icon: 'cil-airplane-mode',
			},

			/** POINTS DE VENTE */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Points de vente'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Gestion points de vente',
				to: '/points-of-sale/management',
				icon: 'cil-star',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Transporteurs',
				to: '/carriers/management',
				icon: 'cil-star',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Historique facturation',
				to: '/points-of-sale/history',
				icon: 'cil-star',
			},

			/** POINTS DE RETRAIT */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Points de retrait'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Listing colis',
				to: '/pick-up-points/packages-listing',
				icon: 'cil-star',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Gestion des points de retrait',
				route: 'list',
				to: '/pick-up-points/list',
				icon: 'cil-settings',
			},

			/** MANIFESTES */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Manifestes'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'EDI & SHPNOTCUS',
				to: '/manifest/shop-notify-customer',
				icon: 'cil-star',
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Sûreté aérienne',
				to: '/manifest/aerial',
				icon: 'cil-star',
			},

			/** Catalog */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Catalogue'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Produits',
				to: '/catalog/products',
				icon: 'cil-star',
			},

			/** ADMINISTRATION */
			{
				_name: 'CSidebarNavTitle',
				_children: ['Administration'],
			},
			{
				_name: 'CSidebarNavItem',
				name: 'Raisons litiges',
				to: '/administration/raisons-litige',
				icon: 'cil-settings',
			},
		],
	},
];
